/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerUploadDbFileMultipartBody } from '../dto/customer-upload-db-file-multipart-body';

export interface PostCustomerUploadDbFileParams {
  body: CustomerUploadDbFileMultipartBody;
}

export function httpPostCustomerUploadDbFile(http: HttpClient, data: PostCustomerUploadDbFileParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<number>;
export function httpPostCustomerUploadDbFile(http: HttpClient, data: PostCustomerUploadDbFileParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<number>>;
export function httpPostCustomerUploadDbFile(http: HttpClient, data: PostCustomerUploadDbFileParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  const body = data.body;
  const form = new FormData();
  if (body.file != null) {
    form.append('File', body.file);
  }
  return http.post<number>(`{placeholder}/Customer/UploadDbFile`, form, options as any);
};

export const urlPostCustomerUploadDbFile = (baseUrl: string, data: PostCustomerUploadDbFileParams) => {
  return `${baseUrl}/Customer/UploadDbFile`;
};
